// extracted by mini-css-extract-plugin
export default {"component":"styles_component__zvbR2"};